import { OurProjectsImages } from '../imageURLs';

export const similarProjects = [
  {
    id: 1,
    ctaTitle: "O'Callaghan Park, Zillmere",
    ctaHref: '/o-callaghan-park',
    imagePath: OurProjectsImages.image2,
  },
  {
    id: 2,
    ctaTitle: 'Dolphins Stadium, Redcliffe',
    ctaHref: '/dolphins-stadium',
    imagePath: OurProjectsImages.image1,
  },
  {
    id: 3,
    ctaTitle: 'Taigum Place Park, Taigum',
    ctaHref: '/taigum-park',
    imagePath: OurProjectsImages.image3,
  },
  {
    id: 4,
    ctaTitle: 'Mitchelton Park, Gaythorne',
    ctaHref: '/mitchelton-park',
    imagePath: OurProjectsImages.image4,
  },
  {
    id: 5,
    ctaTitle: 'South Pine Sports Complex, Moreton Bay Region',
    ctaHref: '/south-pine-sports-complex',
    imagePath: OurProjectsImages.image5,
  },
  {
    id: 6,
    ctaTitle: 'Bribie Soccer Complex, Moreton Bay Region',
    ctaHref: '/bribie-soccer-complex',
    imagePath: OurProjectsImages.image6,
  },
  {
    id: 7,
    ctaTitle: 'D.M. Henderson Park',
    ctaHref: '/henderson-park',
    imagePath: OurProjectsImages.image7,
  },
  {
    id: 8,
    ctaTitle: 'Stanley Day Park',
    ctaHref: '/stanley-day-park',
    imagePath: OurProjectsImages.image8,
  },
  {
    id: 9,
    ctaTitle: 'Giffin Park, Coorparoo',
    ctaHref: '/giffin-park',
    imagePath: OurProjectsImages.image9,
  },
];
